const START_YEAR: number = 2025; //TODO: move to cdk config
const CUTOVERDATE: string = '12-31'; // don't change this value because it is used in the calculation of active year. The cutover date is the date when the new year becomes active. It is set to 30th December because the new year is considered active from 1st January of the next year.
const PREVIOUS_YEAR_COUNT: number = 5;

// These functions are created for the purpose of mocking in tests, and can be extended in the future to store all the date config in database
export const getStartYear = (): number => {
  return START_YEAR;
};

export const getCutoverDate = (): string => {
  return CUTOVERDATE;
};

export const getPreviousYearCount = (): number => {
  return PREVIOUS_YEAR_COUNT;
};

export const generateCutoverDate = (today: Date) => {
  const year = today.getFullYear();
  const cutoverDate = new Date(year + '-' + getCutoverDate());
  cutoverDate.setHours(0, 0, 0, 0);
  const month = String(cutoverDate.getMonth() + 1).padStart(2, '0');
  const day = String(cutoverDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getActiveYear = (): number => {
  const now = new Date();
  now.setHours(0, 0, 0, 0); // Reset time to midnight
  const cutoverDate = new Date(generateCutoverDate(now));
  cutoverDate.setHours(0, 0, 0, 0);
  const isBeforeCutover = now < cutoverDate;
  const activeYear = Math.max(getStartYear(), isBeforeCutover ? now.getFullYear() : cutoverDate.getFullYear() + 1);
  return activeYear;
};

// as there won't be any data for previous years when AWMS is first launched
// we only want to display the last 5 years count from the start year
// Note: All users can see next year data (activeYear + 1); editing it requires READ_WRITE or admin.
// The read-only protection for past years and years beyond next year is enforced by canSave() in auth-service.ts.
export const getYears = (): string[] => {
  const activeYear = getActiveYear();
  const years: number[] = [];
  const prevYearsCountFromCutoverYear = activeYear - getStartYear();
  const prevYearsCount =
    prevYearsCountFromCutoverYear > getPreviousYearCount() ? getPreviousYearCount() : prevYearsCountFromCutoverYear;
  years.push(activeYear + 1);
  for (let i = 0; i <= prevYearsCount; i++) {
    years.push(activeYear - i);
  }
  return years.toString().split(',');
};
